import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { TripCreationRequest, TripData, TripEditRequest, TripSearchFilter, TripState } from "../../models/trip.model";

export const tripCreationRequest = createAction(
        '[Trip] Trip creation request', props<{ tripCreationRequest: TripCreationRequest }>());

export const tripCreationSuccess = createAction(
        '[Trip] Trip creation success', props<{ createdTrip: TripData }>());

export const tripCreationFail = createAction(
        '[Trip] Trip creation fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripEdit = createAction(
        '[Trip] Trip edit', props<{ tripToEdit: TripData }>());

export const tripView = createAction(
        '[Trip] Trip view', props<{ tripToView: TripData }>());

export const tripCopy = createAction(
        '[Trip] Trip copy', props<{ tripToCopy: TripData }>());

export const tripEditSave = createAction(
        '[Trip] Trip edit save', props<{ tripToEdit: TripEditRequest, backToSearch: boolean }>());

export const tripEditSaveSuccess = createAction(
        '[Trip] Trip edit save success', props<{ editedTrip: TripData, backToSearch: boolean }>());

export const tripEditSaveFail = createAction(
        '[Trip] Trip edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripSearchRequest = createAction(
        '[Trip] Trip search request', props<{ searchFilter: TripSearchFilter }>());

export const tripSearchAllRequest = createAction(
        '[Trip] Trip search all request');

export const tripSearchSuccess = createAction(
        '[Trip] Trip search success', props<{ searchResult: TripData[] }>());

export const tripSearchDataReset = createAction(
        '[Trip] Trip search data reset');

export const tripSearchFail = createAction(
        '[Trip] Trip search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const tripDeleteRequest = createAction(
        '[Trip] Trip delete request', props<{ tripId: number }>());

export const tripDeleteSuccess = createAction(
        '[Trip] Trip delete success', props<{ tripId: number }>());

export const tripDeleteFail = createAction(
        '[Trip] Trip delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

/**
 * Request to change the state of a trip.
 * When skipSideEffects is true only the state change is performed: the side effects normally tied to the
 * target state (e.g. the ones of PAID_BY_CUSTOMER) are not executed (used when restoring a CANCELLED trip).
 */
export const tripStateChangeRequest = createAction(
        '[Trip] Trip state change request', props<{ tripId: number, newState: TripState, navigationAfterStateChange: string, skipSideEffects?: boolean }>());

export const tripStateChangeSuccess = createAction(
        '[Trip] Trip state change success', props<{ editedTrip: TripData, navigationAfterStateChange: string }>());

export const tripStateChangeFail = createAction(
        '[Trip] Trip state change fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

/**
 * The trip has been reloaded from the backend (e.g. after a rejected state change): the row in the
 * search results must be replaced with the reloaded trip.
 */
export const tripRefreshSuccess = createAction(
        '[Trip] Trip refresh success', props<{ trip: TripData }>());
